import e from"styled-components";import t from"react";import o from"prop-types";import{Row as r}from"react-styled-flexboxgrid";const a={children:o.node.isRequired},i=e.div.withConfig({displayName:"RowWrapper",componentId:"VDS__sc-kr4awm-0"})`
  width: 100%;
`,m=e(r).withConfig({displayName:"StyledRow",componentId:"VDS__sc-kr4awm-1"})`
  max-width: 1272px;
`,p=function(e){return t.createElement(i,{bleed:e.bleed,className:e.className},t.createElement(m,Object.assign({},e),e.children))};p.propTypes=a;export{p as default};
